export const canvasBody = {
    width: "300px"
};
